import classnames from 'classnames';
import React from 'react';

import { Edit } from '../../../icons/Edit';
import { Button } from '../../material-ui/Button';
import { useStyles } from '../useStyles';

const ManualEditShortcut = ({ shortcut, currentValue, clickHandler }) => {
    const classes = useStyles();
    const { value } = shortcut;
    const isCurrentValue = React.useMemo(() => currentValue === value.toString(), [value, currentValue]);

    return (
        <Button onMouseDown={clickHandler} value={value} className={classnames(classes.shortcut, classes.text)} disabled={isCurrentValue}>
            <Edit size="small" />
        </Button>
    );
};

export { ManualEditShortcut };
